<template>
  <v-btn
    flat
    icon
    color="white"
    @click="share">
    <fa-icon
      :icon="['fab', 'twitter']"
      fixed-width
      size="lg"
      style="color: #55acee"/>
  </v-btn>
</template>

<script>
export default {
  methods: {
    share() {
      // open twitter share window
      window.open(
        `https://twitter.com/intent/tweet?text=${encodeURIComponent(
          'Understanding the Belt & Road'
        )}&url=${encodeURIComponent(window.location.href)}&via=konti_sg`,
        'ShareOnTwitter'
      );
    },
  },
};
</script>
